
<section
  class="w-full flex flex-col justify-center items-center font-rubik bg-themeComponentBg-light px-5 lg:px-0"
  aria-labelledby="about-ca-heading"
>
  <div class="flex flex-col gap-6 justify-center items-center about-ca-container">
    <h2 id="about-ca-heading" v-html="heading"></h2>

    <article v-html="contentHtml" class="text-center lg:text-left"></article>

    <div class="w-full flex justify-center gap-4 pt-5 lg:pt-6">
      <button
        type="button"
        aria-label="Get a quote"
        class="about-ca-get-quote-btn flex flex-col items-center justify-center"
        data-vue-init="lead-flow"
        data-props='{ "gtag": "get_quote"}'
      >
        <p>Get Quote</p>
      </button>
    </div>
  </div>
</section>
